/* eslint-disable no-unsafe-optional-chaining */
import { AxiosResponse, AxiosError } from 'axios';
import { Dispatch } from 'redux';

import { ReduxAction } from '..';
import { ApiRequest, ApiResponse, ApiResponseError } from './_prototype';
import { API } from './reducer';

export * from './_prototype';

export const apiRequest = <Res>({ label, action, fulfilled, rejected, callback }: ApiRequest<Res>) => (dispatch: Dispatch<ReduxAction<Res>>) => {
  // , getState: () => any) => {
  dispatch({ type: `${label}_PENDING` });
  dispatch({ type: `${API}_PENDING` });

  // const ownerId = getState().auth?.owner_id

  return {
    type: label,
    payload: action // (ownerId)
      .then((response: AxiosResponse<ApiResponse<Res>>) => {
        const { status, data } = response || {};
        const { success } = data || {};
        if (success || status === 200) {
          dispatch({
            type: `${label}_FULFILLED`,
            payload: fulfilled(data || null, dispatch),
          });
          if (callback) callback(data);
        } else {
          dispatch({
            type: `${label}_REJECTED`,
            payload: rejected(data || {}, dispatch),
          });
          if (callback) callback(data);
        }
        dispatch({
          type: `${API}_FULFILLED`,
          payload: { label, fulfilled: success },
        });
        if (callback) callback(data);
      })
      .catch((responseError: AxiosError<ApiResponseError>) => {
        if (responseError?.response) {
          const { status, statusText } = responseError?.response;
          const { data, msg, error } = responseError?.response?.data;
          dispatch({
            type: `${label}_REJECTED`,
            payload: rejected(
              {
                data,
                msg,
                error,
                status,
                status_text: statusText,
              },
              dispatch
            ),
          });
          if (callback) callback(data);
        } else {
          dispatch({
            type: `${label}_REJECTED`,
            payload: rejected(
              {
                msg: `Error Occurred${
                  responseError.message ? `, ${responseError.message}` : ''
                }`,
                error: responseError,
              },
              dispatch
            ),
          });
          if (callback) callback(responseError);
        }
        dispatch({
          type: `${API}_REJECTED`,
          payload: { label, error: responseError },
        });
        if (callback) callback(responseError);
      }),
  };
};
